<template>
  <div class="number-input-filter">
    <div class="items">
      <div
        @click.stop="toggleOption(option)"
        :class="{'item-selected': isOptionSelected(option)}"
        v-for="option in options"
        :key="option"
      >
        <div>
          {{ option }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent} from '@vue/composition-api';

export default defineComponent({
  name: 'multi-option-filter',
  props: {
    value: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, {emit}) {
    const isOptionSelected = (option) => {
      return props.value.includes(option);
    };

    const toggleOption = (option) => {
      if (isOptionSelected(option)) {
        const newValue = props.value
          .split(', ')
          .filter((x) => x !== option)
          .join(', ');
        emit('input', newValue);
      } else {
        const newValue = props.value
          .split(', ')
          .concat(option)
          .filter(Boolean)
          .join(', ');
        emit('input', newValue);
      }
    };

    return {
      isOptionSelected,
      toggleOption,
    };
  },
});
</script>

<style scoped>
.number-input-filter {
  position: relative;
}
.number-input-filter .items {
  position: absolute;
  left: -12px;
  z-index: 1;
  min-width: fit-content;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: var(--dropdown-shadow, 0px 0px 33px rgba(0, 0, 0, 0.13));
  background-color: var(--dropdown-bg-color, #fff);
  font-size: 18px;
  text-align: center;
}

.number-input-filter .items div {
  padding: 4px;
  cursor: pointer;
  user-select: none;
  background: #fff;
  color: #556b90;
  font-weight: 500;
  height: 40px;
  display: flex;
  align-items: center;
}

.number-input-filter .items div:not(:last-of-type) {
  border-bottom: 1px solid var(--select-divider, #f1f1f1);
}

.number-input-filter .items div > div {
  padding: 0 36px;
  border-radius: 5px;
  width: 100%;
  justify-content: center;
}

.number-input-filter .items div > div:hover {
  background-color: #f1f1f1;
}

.number-input-filter > .items > .item-selected div {
  position: relative;
  color: #011d3d;
  font-weight: bold !important;
}

.item-selected div::before {
  content: '';
  position: absolute;
  top: 20px;
  left: 8px;
  margin: -8px -8px 0 0;
  opacity: 1;
  transform: none;
  width: 12px;
  height: 12px;
  border-radius: 14px;
  background-color: var(--primary-color, #2c70c9);
  background-image: url("data:image/svg+xml,%3Csvg width='6' height='5' viewBox='0 0 6 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.3215 0.617066C5.53299 0.794617 5.56051 1.11 5.38296 1.3215L2.86444 4.3215C2.76944 4.43466 2.62925 4.50001 2.48149 4.50001C2.33374 4.50001 2.19355 4.43466 2.09855 4.3215L0.617066 2.55679C0.439515 2.3453 0.467031 2.02991 0.678526 1.85236C0.890021 1.67481 1.20541 1.70233 1.38296 1.91382L2.48149 3.22237L4.61707 0.678526C4.79462 0.467031 5.11 0.439515 5.3215 0.617066Z' fill='white'/%3E%3C/svg%3E%0A");
  background-size: 7px;
  background-position: 3px 3px;
  background-repeat: no-repeat;
}
</style>
